export enum Features {
  Aio = 'aio',
  BrokeredLoan = 'brokeredLoan',
  Conditions = 'conditions',
  ConversationLog = 'conversationLog',
  Credit = 'credit',
  Disclosures = 'disclosures',
  DocumentManagement = 'documentsManagement',
  DU = 'du',
  FeeSheet = 'feeSheet',
  Lead = 'leadManager',
  LeadManagementQueue = 'leadManagementQueue',
  Loan = 'loan',
  Loan1008 = '1008',
  LoanComparison = 'loanComparison',
  LoanSummary = 'loanSummary',
  LP = 'lp',
  PasswordReset = 'passwordReset',
  PermissionSettings = 'permissionSettings',
  Pipeline = 'pipeline',
  PreQualificationLetter = 'preQualificationLetter',
  Pricing = 'pricing',
  ProfileSetup = 'profileSetup',
  ProfileSwitch = 'profileSwitch',
  RateSheet = 'rateSheets',
  ScenarioPricing = 'scenarioPricing',
  ServicingPipeline = 'servicingPipeline',
  Upload32 = 'upload3.2',
  VAInformation = 'vaInformation',
  VerificationService = 'verificationService',
  VerificationStatus = 'verificationStatus',
}

export enum PermissionType {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
  Print = 'print',
  View = 'view',
}
